/* ============================================================
   ROBERTO DESTARAC PHOTOGRAPHY — Theme JavaScript
   rdp-theme.js · Vanilla JS · Zero dependencies
   ============================================================ */

(function () {
  'use strict';

  /* ─── REDUCED MOTION CHECK ─────────────────────────────── */
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  /* ─── NAVIGATION SCROLL STATE ──────────────────────────── */
  const nav  = document.getElementById('rdp-nav');
  const hero = document.getElementById('rdp-hero');

  if (nav && hero) {
    const navObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          nav.classList.toggle('is-scrolled', !entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    navObserver.observe(hero);
  }

  /* ─── HERO PARALLAX ────────────────────────────────────── */
  const heroWrap = document.querySelector('.rdp-hero__image-wrap');
  let ticking = false;

  function updateParallax() {
    if (!heroWrap) return;
    const scrollY = window.scrollY;
    const vh      = window.innerHeight;
    const progress = Math.min(scrollY / (vh * 0.3), 1);
    heroWrap.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
    heroWrap.style.opacity   = String(1 - progress);
    ticking = false;
  }

  if (heroWrap && !prefersReducedMotion) {
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ─── SECTION REVEAL ON SCROLL ─────────────────────────── */
  const revealEls = document.querySelectorAll('.rdp-reveal');

  if (revealEls.length > 0) {
    if (prefersReducedMotion) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      const revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
      );
      revealEls.forEach(function (el) {
        revealObserver.observe(el);
      });
    }
  }

  /* ─── MOBILE MENU ──────────────────────────────────────── */
  const hamburger  = document.getElementById('rdp-hamburger');
  const mobileMenu = document.getElementById('rdp-mobile-menu');
  const menuClose  = document.getElementById('rdp-menu-close');

  function openMenu() {
    if (!mobileMenu || !hamburger) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (menuClose) menuClose.focus();
  }

  function closeMenu() {
    if (!mobileMenu || !hamburger) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hamburger.focus();
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (
      e.key === 'Escape' &&
      mobileMenu &&
      mobileMenu.classList.contains('is-open')
    ) {
      closeMenu();
    }
  });

  /* ─── SIGNATURE PAUSE LINE STAGGER ─────────────────────── */
  const pauseLines   = document.querySelectorAll('.rdp-pause__line');
  const pauseSection = document.querySelector('.rdp-pause');

  if (pauseLines.length > 0 && pauseSection) {
    if (prefersReducedMotion) {
      pauseLines.forEach(function (line) {
        line.classList.add('is-visible');
      });
    } else {
      const pauseObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              pauseLines.forEach(function (line, i) {
                setTimeout(function () {
                  line.classList.add('is-visible');
                }, i * 150);
              });
              pauseObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );
      pauseObserver.observe(pauseSection);
    }
  }

})();
